export enum OrderTab {
  PAYMENTS = 'payments',
  SUMMARY = 'summary',
}
